import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _approvalRequest = {
    createdAt: 'google.protobuf.Timestamp',
    joinRequest: '_joinRequest',
    invitation: '_invitation',
    stepConfirmation: '_stepConfirmation',
    resolution: '_resolution',
};
var _document = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    thumbnail: '_image',
};
var _entitySummary = { media: '_mediaItem' };
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getApprovalRequestRequest = {};
var _getApprovalRequestResponse = { request: '_approvalRequest' };
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _invitation = { challenge: '_entitySummary' };
var _joinRequest = { challenge: '_entitySummary' };
var _listApprovalRequestsRequest = {};
var _listApprovalRequestsResponse = { requests: '_approvalRequest' };
var _mediaItem = { image: '_image', video: '_video', document: '_document' };
var _resolution = { createdAt: 'google.protobuf.Timestamp' };
var _resolveApprovalRequestRequest = {};
var _resolveApprovalRequestResponse = {};
var _stepConfirmation = {
    challenge: '_entitySummary',
    step: '_entitySummary',
};
var _video = { thumbnail: '_image' };
function resolveComWixpressAchievementsApiV1ApprovalRequestsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/approval-requests',
                destPath: '/api/v1/approval-requests',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/approval-requests',
                destPath: '/api/v1/approval-requests',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/approval-requests',
                destPath: '/api/v1/approval-requests',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/approval-requests',
                destPath: '/api/v1/approval-requests',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/approval-requests',
                destPath: '/api/v1/approval-requests',
            },
        ],
        _: [
            {
                srcPath: '/_api/challenge-service-web/api/v1/approval-requests',
                destPath: '/api/v1/approval-requests',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/challenge-service-web/api/v1/approval-requests',
                destPath: '/api/v1/approval-requests',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/approval-requests',
                destPath: '/api/v1/approval-requests',
            },
        ],
        'challenges.wixapps.net': [
            {
                srcPath: '/api/v1/approval-requests',
                destPath: '/api/v1/approval-requests',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function listApprovalRequests(payload) {
    var _a = serializer(_listApprovalRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listApprovalRequestsResponse, {
        _approvalRequest: _approvalRequest,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _invitation: _invitation,
        _joinRequest: _joinRequest,
        _mediaItem: _mediaItem,
        _resolution: _resolution,
        _stepConfirmation: _stepConfirmation,
        _video: _video,
    }).fromJSON;
    function __listApprovalRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.approval_request',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ApprovalRequestsService.ListApprovalRequests',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ApprovalRequestsServiceUrl({
                protoPath: '/api/v1/approval-requests',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listApprovalRequests.fromReq = fromReq;
    __listApprovalRequests.__isAmbassador = true;
    return __listApprovalRequests;
}
export function getApprovalRequest(payload) {
    var _a = serializer(_getApprovalRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getApprovalRequestResponse, {
        _approvalRequest: _approvalRequest,
        _document: _document,
        _entitySummary: _entitySummary,
        _focalPoint: _focalPoint,
        _image: _image,
        _invitation: _invitation,
        _joinRequest: _joinRequest,
        _mediaItem: _mediaItem,
        _resolution: _resolution,
        _stepConfirmation: _stepConfirmation,
        _video: _video,
    }).fromJSON;
    function __getApprovalRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.approval_request',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ApprovalRequestsService.GetApprovalRequest',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ApprovalRequestsServiceUrl({
                protoPath: '/api/v1/approval-requests/{requestId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getApprovalRequest.fromReq = fromReq;
    __getApprovalRequest.__isAmbassador = true;
    return __getApprovalRequest;
}
export function resolveApprovalRequest(payload) {
    var _a = serializer(_resolveApprovalRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveApprovalRequestResponse, {}).fromJSON;
    function __resolveApprovalRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.approval_request',
            method: 'PUT',
            methodFqn: 'com.wixpress.achievements.api.v1.ApprovalRequestsService.ResolveApprovalRequest',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ApprovalRequestsServiceUrl({
                protoPath: '/api/v1/approval-requests/{requestId}/resolution',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveApprovalRequest.fromReq = fromReq;
    __resolveApprovalRequest.__isAmbassador = true;
    return __resolveApprovalRequest;
}
//# sourceMappingURL=http.impl.js.map